/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Full_Permissions_TooltipInputs */



/**
* | output |
* | --- |
* | "Gives users full access to all Event Groups, including those created in the future" |
*
* @param {Team_Share_Full_Permissions_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_full_permissions_tooltip = /** @type {((inputs?: Team_Share_Full_Permissions_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Full_Permissions_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Donne aux utilisateurs un accès complet à tous les groupes d’événements, y compris ceux créés à l’avenir")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gewährt Benutzern vollen Zugriff auf alle Ereignisgruppen, einschließlich der zukünftig erstellten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fornisce agli utenti l'accesso completo a tutti i gruppi di eventi, compresi quelli creati in futuro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предоставляет пользователям полный доступ ко всем группам событий, включая те, которые будут созданы в будущем.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proporciona a los usuarios acceso completo a todos los grupos de eventos, incluidos aquellos creados en el futuro.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用户能够完全访问所有活动组，包括未来创建的活动组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("将来作成されるものも含め、すべてのイベント グループへのフル アクセスをユーザーに付与します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ताओं को भविष्य में बनाए जाने वाले इवेंट ग्रुप्स सहित सभी इवेंट ग्रुप्स तक पूर्ण पहुंच प्रदान करता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Concede aos usuários acesso total a todos os Grupos de Eventos, incluindo aqueles que forem criados no futuro.")
	return /** @type {LocalizedString} */ ("Gives users full access to all Event Groups, including those created in the future")
});